import { Dashboard } from "../constants/dashboard";
export var getStatsTileData = function (username) {
    return {
        type: Dashboard.Stats_Tiles,
        username: username,
    };
};
export var getQuesAttemptDetails = function (username) {
    return {
        type: Dashboard.Ques_Attempt_Details,
        username: username,
    };
};
export var AdviserInfoAction = function (username) {
    return {
        type: Dashboard.Adviser_Info,
        payload: username,
    };
};
export var updateNeedsQuestionnaire = function (needsQuestionnaire) {
    return {
        type: Dashboard.Update_Needs_Questionnaire,
        payload: needsQuestionnaire,
    };
};
export var updateTermsAccepted = function (accepted) { return ({
    type: Dashboard.Update_Terms_Accepted,
    payload: accepted,
}); };
export var updatePrivacyPolicyAccepted = function (accepted) { return ({
    type: Dashboard.Update_Privacy_Policy_Accepted,
    payload: accepted,
}); };
export var makeQuesFieldReady = function (data, toggle, field) {
    if (field === void 0) { field = "second_attempt_ready"; }
    return {
        type: Dashboard.Update_Ques_Attempt_Details,
        data: data,
        toggle: toggle,
        field: field,
    };
};
export var clearDashboardForProfileSwitch = function () {
    return {
        type: Dashboard.Clear_Dashboard_For_Profile_Switch,
    };
};
export var getObligationsHistory = function (username) { return ({
    type: Dashboard.Obligations_History,
    username: username,
}); };
